import { CartesianGrid, Legend, XAxis, YAxis } from 'recharts';
import {
  AdproductsMoodysReportType,
  type CustomerAnalyticsMoodysAskingRentVacancyDto,
  type CustomerAnalyticsMoodysReportDto,
} from '@zg-rentals/ts-customer-analytics-client';
import { Label } from 'recharts';
import { renderChartToPdf } from './pdfImageUtils';
import { LineChart } from 'recharts';
import { Line } from 'recharts';

interface VacancyTrendsChartProps {
  report: CustomerAnalyticsMoodysReportDto;
}

const VacancyTrendsChart = ({ report }: VacancyTrendsChartProps) => {
  const hasSubmarketData = report.reportType === AdproductsMoodysReportType.SUBMARKET;
  const currentYear = new Date().getFullYear();
  const maxYearsInPast = 10;
  const maxYearsInFuture = 0;
  const yearFilter = (item: CustomerAnalyticsMoodysAskingRentVacancyDto) =>
    currentYear - maxYearsInPast <= item.year && item.year <= currentYear + maxYearsInFuture;

  const submarketData = report.askingRentVacancyTrendsReport.submarket;
  const marketData = report.askingRentVacancyTrendsReport.market;

  const data = marketData
    .filter(yearFilter)
    .sort((a, b) => a.year - b.year)
    .map((item) => ({
      name: item.year,
      marketRent: item.vacancyPercent,
      submarketRent: submarketData?.find((marketReport) => marketReport.year === item.year)?.vacancyPercent,
    }));

  return (
    <LineChart
      width={1400}
      height={500}
      data={data}
      margin={{
        top: 10,
        right: 5,
        left: 20,
        bottom: 30,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis tickFormatter={(value: number) => (value * 100).toFixed(2) + '%'}>
        <Label
          value="% Vacant"
          offset={-8}
          angle={-90}
          position="insideLeft"
          style={{ textAnchor: 'middle', fontSize: '30px' }}
        />
      </YAxis>
      <Legend wrapperStyle={{ position: 'relative', fontSize: '30px', marginTop: '-15px' }} />
      {hasSubmarketData && (
        <Line
          isAnimationActive={false}
          dataKey="submarketRent"
          stroke="#001851"
          dot={false}
          name={report.submarketName}
          strokeWidth={6}
        />
      )}
      <Line
        isAnimationActive={false}
        dataKey="marketRent"
        stroke={hasSubmarketData ? '#b7b7b7' : '#001851'}
        dot={false}
        name={report.marketName}
        strokeWidth={6}
      />
    </LineChart>
  );
};

export const renderVacancyTrendsChart = async (report: CustomerAnalyticsMoodysReportDto): Promise<string> => {
  return await renderChartToPdf(<VacancyTrendsChart report={report} />);
};
